import { render, staticRenderFns } from "./VaimoTopNavigation.vue?vue&type=template&id=03aa81b6&scoped=true&"
import script from "./VaimoTopNavigation.vue?vue&type=script&lang=ts&"
export * from "./VaimoTopNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoTopNavigation.vue?vue&type=style&index=0&id=03aa81b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aa81b6",
  null
  
)

export default component.exports